<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper" [ngClass]="{'show-sidebar': showMobileMenu}" dir="ltr" data-theme="light" data-layout="vertical"
    [attr.data-sidebartype]="sidebartype" data-sidebar-position="absolute" data-header-position="fixed"
    data-boxed-layout="full">
    <!-- ============================================================== -->
    <!-- Topbar header - style you can find in topbar.scss -->
    <!-- ============================================================== -->
    <header class="topbar" data-navbarbg="skin1">
        <nav class="d-flex top-navbar navbar-expand-md navbar-light">
            <div class="navbar-header" [ngClass]="(expandLogo)?'expand-logo':''" data-logobg="theme-light">
                <!-- This is for the sidebar toggle which is visible on mobile only -->
                <a (click)="showMobileMenu = !showMobileMenu" class="nav-toggler waves-effect waves-light d-block d-md-none"
                    href="javascript:void(0)">
                    <i [ngClass]="(showMobileMenu)?'ti-close':'ti-menu'"></i>
                </a>
                <!-- ============================================================== -->
                <!-- Logo -->
                <!-- ============================================================== -->
                
                    <a class="navbar-brand" href="/">
                        <!-- Logo icon -->
                        <b class="logo-icon">
                            <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                            <!-- Light Logo icon -->
                            <img src="assets/images/logo-expoGdl.png" alt="homepage" class="wrap-logo img-fluid" />
                        </b>
                        <!--End Logo icon -->
                        <!-- Logo text -->
                        <!-- <span class="logo-text"> -->
                            <!-- Light Logo text -->
                            
                            <!-- <img src="assets/images/logo-light-text.png" class="dark-logo" alt="homepage" /> -->
                        <!-- </span> -->
                    </a>
                
                <!-- ============================================================== -->
                <!-- End Logo -->
                <!-- ============================================================== -->
                <!-- ============================================================== -->
                <!-- Toggle which is visible on mobile only -->
                <!-- ============================================================== -->
                <a class="topbartoggler d-block d-md-none waves-effect waves-light" href="javascript:void(0)"
                    data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <i class="ti-more"></i>
                </a>
            </div>
            <!-- ============================================================== -->
            <!-- End Logo -->
            <!-- ============================================================== -->
            <div class="navbar-collapse collapse" id="navbarSupportedContent" data-navbarbg="skin6">
                <app-navigation (toggleSidebar)="toggleSidebarType()" class="w-100"></app-navigation>
            </div>
        </nav>
    </header>
    <!-- ============================================================== -->
    <!-- Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <aside class="left-sidebar" data-sidebarbg="skin6" (mouseover)="Logo()" (mouseout)="Logo()">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar" [perfectScrollbar]="config">
			<div class="user-profile">
		      <!-- User profile image -->
		      <div class="profile-img"> <!-- <img src="assets/images/users/profile.png" alt="user" /> -->
		        <!-- this is blinking heartbit-->
		        <div class="notify setpos"> <span class="heartbit"></span> <span class="point"></span> </div>
		      </div>
		      <!-- User profile text-->
		      <div ngbDropdown [autoClose]="true" class="profile-text">
		        <a ngbDropdownToggle data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="true">
                    {{user.nombre}} {{user.apellido_paterno}}
                    <i class="fa fa-angle-down"></i></a>
		        <div ngbDropdownMenu class="dropdown-menu animated flipInY">
		          <!-- text-->
		          <!-- <a href="#" class="dropdown-item"><i class="ti-user"></i> My Profile</a>
		          <a href="#" class="dropdown-item"><i class="ti-wallet"></i> My Balance</a>
		          <a href="#" class="dropdown-item"><i class="ti-email"></i> Inbox</a>
		          <div class="dropdown-divider"></div>
		          <a href="#" class="dropdown-item"><i class="ti-settings"></i> Account Setting</a>
		          <div class="dropdown-divider"></div> -->
		          <a role="button" class="dropdown-item" (click)="logout()"><i class="fa fa-power-off"></i> Logout</a>
		          <!-- text-->
		        </div>
		      </div>
		    </div>
            <app-sidebar></app-sidebar>
        </div>
    </aside>
    <!-- ============================================================== -->
    <!-- End Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <app-breadcrumb></app-breadcrumb>
        <div class="container-fluid">
        	
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <router-outlet></router-outlet>
            
            <!-- ============================================================== -->
            <!-- End Start Page Content -->
            <!-- ============================================================== -->
        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- footer -->
        <!-- ============================================================== -->
        <footer class="footer text-center">
            Spin AR - 2020
        </footer>
        <!-- ============================================================== -->
        <!-- End footer -->
        <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
</div>